import dayjs from 'dayjs';

const adulthood = 18;
const minYear = 1900;

export const MONTHS_PER_YEAR = 12;
export const MIN_YEAR_OF_BUILD = 1600;
export const MAX_YEAR_OF_BUILD = 2100;
export const VALID_HISTORY_PERIOD_IN_YEARS = 2;
export const VALID_HISTORY_PERIOD_IN_MONTHS = VALID_HISTORY_PERIOD_IN_YEARS * MONTHS_PER_YEAR;

export const TODAY_DATE = dayjs().startOf('day').toDate();
export const LAST_YEAR_DATE = dayjs().subtract(1, 'year').toDate();

export const MIN_DATE = dayjs().set('years', minYear).toDate();
export const ADULTHOOD_DATE = dayjs().subtract(adulthood, 'years').toDate();

export const DATE_PICKER_DATE_FORMAT = 'MM/dd/yyyy';
export const LAST_MODIFIED_DATE_FORMAT = 'MM.DD.YYYY';

export const MS_PER_SECOND = 1000;
